/* Mycelium Threadz theme JS */
(function () {
  // nav scroll state
  var nav = document.getElementById('SiteNav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // marquee duplication
  var track = document.getElementById('MarqueeTrack');
  if (track) track.innerHTML = track.innerHTML.repeat(6);

  // reveal on scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  // hero spores
  var canvas = document.getElementById('spores');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (canvas && !reduced) {
    var ctx = canvas.getContext('2d');
    var spores = [];
    var sizeCanvas = function () {
      canvas.width = window.innerWidth;
      canvas.height = canvas.parentElement.offsetHeight;
    };
    sizeCanvas();
    window.addEventListener('resize', sizeCanvas);
    for (var i = 0; i < 46; i++) {
      spores.push({
        x: Math.random() * window.innerWidth,
        y: Math.random() * window.innerHeight,
        r: Math.random() * 1.8 + 0.4,
        vx: (Math.random() - 0.5) * 0.25,
        vy: -(Math.random() * 0.35 + 0.08),
        o: Math.random() * 0.45 + 0.1,
        w: Math.random() * Math.PI * 2
      });
    }
    (function tick() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#eae0c8';
      spores.forEach(function (s) {
        s.w += 0.01; s.x += s.vx + Math.sin(s.w) * 0.15; s.y += s.vy;
        if (s.y < -6) { s.y = canvas.height + 6; s.x = Math.random() * canvas.width; }
        if (s.x < -6) s.x = canvas.width + 6;
        if (s.x > canvas.width + 6) s.x = -6;
        ctx.globalAlpha = s.o;
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2); ctx.fill();
      });
      ctx.globalAlpha = 1;
      requestAnimationFrame(tick);
    })();
  }

  // ---- AJAX cart drawer ----
  var drawer = document.getElementById('CartDrawer');
  var overlay = document.getElementById('CartOverlay');
  var toastEl = document.getElementById('Toast');
  var toastTimer;

  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2200);
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var sub = document.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = money(cart.items_subtotal_price);
    var box = document.getElementById('CartDrawerItems');
    if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = '<p class="drawer-empty">Your basket is empty.<br>Go pick something from the forest floor.</p>';
      return;
    }
    box.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1') : '';
      return '<div class="drawer-item">' +
        (img ? '<img src="' + img + '" alt="" width="72" height="88">' : '<span></span>') +
        '<div><h4>' + item.product_title + '</h4>' +
        '<div class="meta">' + (item.variant_title || '') + '</div>' +
        '<div class="drawer-qty">' +
        '<button data-line="' + (i + 1) + '" data-q="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button data-line="' + (i + 1) + '" data-q="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
        '</div></div>' +
        '<span class="line-price">' + money(item.final_line_price) + '</span></div>';
    }).join('');
  }

  function refreshCart(open) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      if (open && drawer) { drawer.classList.add('open'); overlay.classList.add('open'); }
      return cart;
    });
  }

  function closeDrawer() {
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); refreshCart(true); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  var itemsBox = document.getElementById('CartDrawerItems');
  if (itemsBox) {
    itemsBox.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-line]');
      if (!b) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(b.dataset.line, 10), quantity: parseInt(b.dataset.q, 10) })
      }).then(function (r) { return r.json(); }).then(renderCart);
    });
  }

  var checkout = document.querySelector('[data-checkout]');
  if (checkout) checkout.addEventListener('click', function (e) { e.preventDefault(); window.location.href = '/checkout'; });

  // intercept product form -> AJAX add -> open drawer
  var productForm = document.querySelector('[data-product-form]');
  if (productForm && window.fetch) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', body: new FormData(productForm) })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () { toast('Added to basket 🍄'); return refreshCart(true); })
        .catch(function () { productForm.submit(); }); // graceful fallback to normal POST
    });
  }

  // product page: option dropdowns -> variant id
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var variants = JSON.parse(form.querySelector('[data-variants]').textContent);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add]');
    var selects = Array.prototype.slice.call(form.querySelectorAll('.opt-select'));

    var findVariant = function () {
      return variants.find(function (v) {
        return selects.every(function (sel) {
          var pos = parseInt(sel.dataset.optionPosition, 10) - 1;
          return v.options[pos] === sel.value;
        });
      });
    };
    var updateVariant = function () {
      var v = findVariant();
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_formatted;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
      }
    };
    selects.forEach(function (sel) { sel.addEventListener('change', updateVariant); });
    if (selects.length) updateVariant();
  }

  // gallery thumbs
  var mainImg = document.querySelector('[data-main-image]');
  if (mainImg) {
    document.querySelectorAll('.thumbs img').forEach(function (t) {
      t.addEventListener('click', function () {
        mainImg.src = t.dataset.full;
        document.querySelectorAll('.thumbs img').forEach(function (x) { x.classList.toggle('active', x === t); });
      });
    });
  }
})();

/* v7: drifting spores on the collections hero */
(function(){
  var c=document.querySelector('canvas[data-spores]');
  if(!c) return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ctx=c.getContext('2d'), W=0,H=0, dpr=Math.min(window.devicePixelRatio||1,2), spores=[];
  function size(){W=c.clientWidth;H=c.clientHeight;c.width=W*dpr;c.height=H*dpr;ctx.setTransform(dpr,0,0,dpr,0,0);}
  function make(){return {x:Math.random()*W,y:H+Math.random()*H,r:Math.random()*2.2+0.5,v:Math.random()*0.35+0.12,sway:Math.random()*Math.PI*2,ss:Math.random()*0.012+0.004,a:Math.random()*0.5+0.22};}
  function init(){size();spores=[];var n=Math.round(Math.min(90,W/12));for(var i=0;i<n;i++){var s=make();s.y=Math.random()*H;spores.push(s);}}
  function tick(){
    ctx.clearRect(0,0,W,H);
    for(var i=0;i<spores.length;i++){var s=spores[i];s.y-=s.v;s.sway+=s.ss;s.x+=Math.sin(s.sway)*0.35;
      if(s.y<-6){spores[i]=make();continue;}
      var g=ctx.createRadialGradient(s.x,s.y,0,s.x,s.y,s.r*3);
      g.addColorStop(0,'rgba(217,142,50,'+s.a+')');g.addColorStop(1,'rgba(217,142,50,0)');
      ctx.fillStyle=g;ctx.beginPath();ctx.arc(s.x,s.y,s.r*3,0,Math.PI*2);ctx.fill();}
    requestAnimationFrame(tick);
  }
  var t;window.addEventListener('resize',function(){clearTimeout(t);t=setTimeout(init,150);});
  init();requestAnimationFrame(tick);
})();
